import { Box, Divider, Grid, Stack } from '@mui/material'
import { useIsSmallScreen } from '../../hooks/useIsSmallScreen'
import { CottageOutlined, LoginRounded, SettingsOutlined, GraphicEq, MusicNote, Lyrics } from '@mui/icons-material'
// import PollIcon from "@mui/icons-material/Poll"

// import EvaluationBtn from "./EvaluationBtn"

import Text from './Text'
import RouteButton from './RouteButton'
import { ROUTES } from '../../utils/api'
import { useCurrentUser } from '../../hooks/contexts/currentUserContext'
import { Logo } from './Logo'
import NowPlaying from './Nowplaying'
// import { getActiveEvaluationID } from "../../firebase/databaseApi"
// import EvaluationActiveModal from "./EvaluationActiveModal";

import { useContext } from 'react'
import { PolyglotContext } from '../../polyglot/polyGlotContext'

interface MenuWithContentProps {
    menuItems?: React.ReactNode
    content: React.ReactNode
    showCurrentlyPlaying?: boolean
    extraPadding?: boolean
    heading?: string
}

const MenuWithContent = ({ menuItems, content, showCurrentlyPlaying, heading }: MenuWithContentProps) => {
    const isSmallScreen = useIsSmallScreen()
    return isSmallScreen ? <MobileMenu menuItems={menuItems} content={content} showCurrentlyPlaying={showCurrentlyPlaying} heading={heading} /> : <DesktopMenu menuItems={menuItems} content={content} showCurrentlyPlaying={showCurrentlyPlaying} />
}

const MobileMenu = ({ menuItems, content, heading }: MenuWithContentProps) => {
    return (
        <Grid container direction="column" sx={{ height: '90%' }}>
            <Grid item>
                {heading && (
                    <Text noWrap size={25}>
                        {heading}
                    </Text>
                )}
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', gap: 1, px: 1 }}>{menuItems}</Box>
            </Grid>

            <Grid item xs sx={{ overflow: 'auto', height: '80%' }}>
                {content}
            </Grid>
        </Grid>
    )
}

const DesktopMenu = ({ menuItems, content, showCurrentlyPlaying }: MenuWithContentProps) => {
    const currentUser = useCurrentUser()
    const { polyglot } = useContext(PolyglotContext)
    // const customerId = currentUser?.customer?.id

    return (
        <>
            <Box sx={{ position: 'absolute', top: 34, left: 0, right: 0, textAlign: 'center' }}>
                <h4>
                    {' '}
                    {polyglot.t('assetsComponents.menuWithContent.h3UserGreeting')}
                    {currentUser && currentUser?.auth.displayName ? ` ${currentUser?.auth.displayName}` : ''}!
                </h4>
            </Box>
            <Box sx={{ position: 'absolute', top: 34, right: 26 }}>
                <RouteButton inHeader route={ROUTES.SETTINGS.MAIN} title={polyglot.t('assetsComponents.menuWithContent.settingsBtn')} icon={SettingsOutlined} />
            </Box>

            <Grid container sx={{ height: '100%' }}>
                <Grid
                    item
                    sx={{
                        width: '220px', // your sidebar width
                        height: '100vh',
                        position: 'sticky',
                        top: 0,
                        boxSizing: 'border-box',
                        p: '32px 24px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        overflow: 'hidden' // clip if something still tries to overflow
                    }}
                >
                    {/* Header */}
                    <Box sx={{ flex: '0 0 auto' }}>
                        <Logo />
                    </Box>

                    {/* Menu (no scroll) */}
                    <Box
                        sx={{
                            flex: '1 1 auto',
                            minHeight: 0, // lets this area shrink if needed
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1.25,
                            // Slightly responsive spacing to save vertical space on short desktops
                            '& .menu-section': { mt: 0 },
                            '& .menu-divider': { my: 0 }
                        }}
                    >
                        {currentUser?.customer ? (
                            <>
                                <Divider className="menu-divider" sx={{ borderColor: '#808080' }} />
                                <RouteButton inHeader route={ROUTES.HOME} title={polyglot.t('assetsComponents.menuWithContent.homeRouteBtn')} icon={CottageOutlined} />
                                <Divider className="menu-divider" sx={{ borderColor: '#808080' }} />
                                <Box className="menu-section" sx={{ display: 'flex' }}>
                                    <Text size="heading" bold>
                                        {polyglot.t('assetsComponents.menuWithContent.libraryHeading')}
                                    </Text>
                                </Box>
                                <RouteButton title={polyglot.t('assetsComponents.menuWithContent.musicRouteBtn')} route={ROUTES.LIBRARY.MUSIC.fullPath} icon={MusicNote} />
                                <RouteButton title={polyglot.t('assetsComponents.menuWithContent.soundscapesRouteBtn')} route={ROUTES.LIBRARY.SOUNDBANKS.fullPath} icon={GraphicEq} />
                                <RouteButton title={polyglot.t('assetsComponents.menuWithContent.keysRouteBtn')} route={ROUTES.LIBRARY.KEY.fullPath} icon={Lyrics} />
                                {/* <Divider orientation="horizontal" sx={{ borderColor: "#808080" }} />
                                <Box sx={{ display: "flex" }}>
                                    <Text size="heading" bold>
                                        {polyglot.t("assetsComponents.menuWithContent.evaluationHeading")}
                                    </Text>
                                </Box>
                                <EvaluationBtn customerId={customerId} />
      
                                <RouteButton title="Fördjupad" route={`${ROUTES.EVALUATION_TOOL}?stage=full`} icon={PollIcon}></RouteButton> 
                            */}
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>{menuItems}</Box>
                            </>
                        ) : (
                            <RouteButton inHeader route={ROUTES.LOG_IN} title={polyglot.t('assetsComponents.menuWithContent.loginRouteBtn')} icon={LoginRounded} />
                        )}
                    </Box>

                    {currentUser && (
                        <>
                            {!currentUser.customer && <RouteButton inHeader route={ROUTES.ACTIVATE_ACCOUNT} title={polyglot.t('assetsComponents.menuWithContent.activateAccountRouteBtn')} sx={{ mb: 1 }} />}
                            <Box sx={{ flex: '0 1 auto' /* allow shrink */, minHeight: 0 }}>
                                <NowPlaying />
                            </Box>
                        </>
                    )}
                </Grid>
                <Grid item xs sx={{ overflow: 'auto', height: '100%', padding: '5rem 0rem 0rem 2rem' }}>
                    {content}
                </Grid>
            </Grid>
        </>
    )
}

export default MenuWithContent
